import React from "react"

export const PublicContainer: React.FC = props => {
    return <div className="bg-gray">{props.children}</div>
}
